import React from "react";
import { TextField } from "@mui/material";
import { BuilderSection } from "areas/orders/builder/BuilderSection";
import type { SectionProps } from "areas/orders/builder/sections/SectionProps";

const notesPlaceholder = "Add internal notes...";

const internalNotesMaxLength = 4000;

function internalNotesCount(length: number): string {
  return `${length.toLocaleString("en-US")}/${internalNotesMaxLength.toLocaleString("en-US")} characters`;
}

export function NotesSection({ draft, setField, readOnly }: SectionProps) {
  const internalNotes = draft.internalNotes ?? "";

  return (
    <BuilderSection title="Notes">
      <TextField
        value={internalNotes}
        onChange={(event) => setField("internalNotes", event.target.value)}
        placeholder={notesPlaceholder}
        multiline
        minRows={4}
        fullWidth
        helperText={internalNotesCount(internalNotes.length)}
        disabled={readOnly}
        // Why: a MUI `label` hides the placeholder until focus.
        slotProps={{
          htmlInput: { "aria-label": "Internal notes", maxLength: internalNotesMaxLength },
        }}
      />
    </BuilderSection>
  );
}
